/**
 * @file Purchase Album Checkout view.
 */

import React from 'react';

import PurchaseAlbumCheckoutContainer from '../../containers/purchase/PurchaseAlbumCheckoutContainer';

const PurchaseAlbumCheckoutView = () => <PurchaseAlbumCheckoutContainer />;

export default PurchaseAlbumCheckoutView;
